// extracted by mini-css-extract-plugin
export default {"container":"ShortcutSettingsPage__container___ZWPMm","item":"ShortcutSettingsPage__item___XN1UJ","subtext":"ShortcutSettingsPage__subtext___v_Chl"};